export type RetryableSocketEvent = (m: MessageEvent<string>) => void;

export class RetryableSocket {
  readonly url: string;

  readonly onConnect: () => void;

  readonly onMsg: RetryableSocketEvent;

  closed = false;

  ws?: WebSocket;

  constructor(url: string, onConnect: () => void, onMsg: RetryableSocketEvent) {
    this.url = url;
    this.onConnect = onConnect;
    this.onMsg = onMsg;
    this.connect();
  }

  connect(retries = 0) {
    if (retries >= 9) return;

    const ws = new WebSocket(this.url);
    ws.onopen = () => {
      // it's possible to have a race condition where this.close is called before onopen happens
      if (this.closed) {
        ws.close();
        return;
      }
      this.onConnect();
      this.ws = ws;
      ws.onmessage = this.onMsg;
    };
    ws.onclose = () => {
      // onclose happens after:
      // - remote server closing connection (need to reconnect)
      // - connection attempt failing (need to reconnect)
      // - this.close was called (nothing to do)

      if (this.closed) return;

      const actualRetry = this.ws ? 0 : retries + 1; // reset retry count if previously connected
      delete this.ws;
      setTimeout(() => this.connect(actualRetry), 2 ** actualRetry * 1000);
    };
  }

  close() {
    this.closed = true;
    this.ws?.close();
  }
}
